module.exports = __webpack_public_path__ + "static/media/a51.92dcf6e2.jpg";